import { formatDate } from "./MomentHelper";

export const getCreatedByInfo = (createdByName, createdDate): string => {
  return "CREATED BY: " + createdByName + " " + formatDate(createdDate);
};

export const isOpenInfo = (acceptedDate, rejectedDate): boolean => {
  if (acceptedDate || rejectedDate) {
    return true;
  }

  return false;
};

export const getApprovalInfo = (acceptedBy, acceptedDate, rejectedBy, rejectedDate): string => {
  let by = acceptedBy;
  let date = formatDate(acceptedDate);
  let info = "ACCEPTED BY: ";
  if (rejectedDate != null) {
    by = rejectedBy;
    date = formatDate(rejectedDate);
    info = "REJECTED BY: ";
  }
  return info + by + " " + date;
};
